import React, { useRef, useMemo } from 'react';
import { useFrame } from '@react-three/fiber';
import { useTexture, Text } from '@react-three/drei';
import * as THREE from 'three';

interface HolographicVinylProps {
    imageUrl?: string;
    artist?: string;
    title?: string;
}

export function HolographicVinyl({ imageUrl, artist, title }: HolographicVinylProps) {
    const meshRef = useRef<THREE.Group>(null);
    const texture = useMemo(() => {
        if (imageUrl) {
            return new THREE.TextureLoader().load(imageUrl);
        }
        return null;
    }, [imageUrl]);

    useFrame((state, delta) => {
        if (meshRef.current) {
            // Spin the record
            meshRef.current.rotation.y += delta * 0.5;
            // Float up and down
            meshRef.current.position.y = 1.5 + Math.sin(state.clock.elapsedTime) * 0.1;
        }
    });

    if (!imageUrl) return null;

    return (
        <group ref={meshRef} position={[2, 1.5, -3]} rotation={[0.5, 0, 0.2]}>
            {/* The Record (Black Vinyl) */}
            <mesh rotation={[Math.PI / 2, 0, 0]}>
                <cylinderGeometry args={[1, 1, 0.05, 64]} />
                <meshStandardMaterial color="#111" roughness={0.5} metalness={0.8} />
            </mesh>

            {/* The Label (Album Art) */}
            {texture && (
                <mesh position={[0, 0, 0.03]} rotation={[Math.PI / 2, 0, 0]}>
                    <circleGeometry args={[0.4, 64]} />
                    <meshBasicMaterial map={texture} />
                </mesh>
            )}
            {texture && (
                <mesh position={[0, 0, -0.03]} rotation={[-Math.PI / 2, 0, 0]}>
                    <circleGeometry args={[0.4, 64]} />
                    <meshBasicMaterial map={texture} />
                </mesh>
            )}

            {/* Holographic Metadata Floating Above */}
            <group position={[0, 1.2, 0]} rotation={[0, -Math.PI / 2, 0]}>
                {/* Note: Rotation correction might be needed depending on view angle */}
            </group>
        </group>
    );
}
